import qs from 'query-string';
import http, { AxiosResponse } from 'utils/http.service';
import { ICountryRes } from './countries.types';

export const getCountries = async (query = '', page = 0): Promise<AxiosResponse<ICountryRes[]>> => {
  const queryString = qs.stringify({ query, offset: page * 20 }, { arrayFormat: 'bracket' });
  return http<ICountryRes[]>(`/geo/countries?${queryString}`);
};

export default { getCountries };